<template>
  <!----------------------------------------------------------------------------->
  <div class="endTimeBody">
    <div class="entry" @click="cb">
      <div class="txt">快捷入口</div>
      <div class="img">
        <img src="../static/open-1.png" v-show="show" />
        <img src="../static/close-1.png" v-show="!show" />
      </div>
    </div>
    <div class="testshow" :class="[show ? 'active' : '']">
      <div
        class="bth"
        v-for="(item, index) in itemTitle"
        :key="index"
        @click="entry(item.url, item.id)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
  <!----------------------------------------------------------------------------->
</template>


<script>
import config from "../../config.js";
export default {
  render: function render(h, _ref) {
    var children = _ref.children;
    var data = {
      on: Transition,
    };
    return h("transition", data, children);
  },
  data() {
    return {
      show: true,
      itemTitle: [
        {
          title: "我要参观",
          id: 0,
          url:config.visit
        },
        {
          title: "我要参展",
          id: 1,
          url:config.ParticipateExhibition
        },
        // {
        //   title: "参观咨询",
        //   id: 2,
        //   url: "#",
        // },
        // {
        //   title: "参展咨询",
        //   id: 3,
        //   url: "#",
        // },
       
      ],
    };
  },
  methods: {
    cb() {
      this.show = !this.show;
    },

    entry(url, id) {
      let itemUrl = url;
      let itemId = id;
      //"我要参观"和"我要参展"选项,新打开一个页面进行跳转
      if (itemId == 0 || itemId == 1) {
        this.jump(itemUrl);
      } else {
        //"参观咨询"和"参展咨询"选项打开im客服,打开一个弹框
         this.$emit('sendId',itemId)
      }
    },
    //跳转新页面,跳转到目标地址
    jump(url) {
      let targetUrl = url;
      let a = document.createElement("a");
      a.setAttribute("href", targetUrl);
      a.setAttribute("target", "_blank");
      a.click();
      a.remove();
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.endTimeBody {
  display: flex;
  width: fit-content;
  border-radius: 10px 0px 0px 10px;
  background: #fdd72a;
  height: 220px;
  
  .entry {
    width: 72px;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
    background: #fdd72a;
    border-top-left-radius: 20px 20px;
    border-bottom-left-radius: 20px 20px;
    .txt {
      word-wrap: break-word;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      padding: 35px 23px 0px 23px;
    }
    .img {
      width: 18px;
      height: 18px;
      padding-top: 24px;
      padding-bottom: 34px;
      padding-left: 26px;
      padding-right: 26px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .testshow {
    width: 152px;
    background: #fdd72a;
    height: 100%;
    box-sizing: border-box;
    padding: 23px 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // 浏览器兼容
    transition: width 1s;
    -moz-transition: width 1s; /* Firefox 4 */
    -webkit-transition: width 1s; /* Safari and Chrome */
    -o-transition: width 1s; /* Opera */
  }
  .bth {
    margin: 0px 16px;
    width: 118px;
    height: 36px;
    background: #fff3bf;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 10px;  //当前只有两个栏目，故而需要撑起来
    &:hover {
      background: #006fb8;
      border-radius: 4px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
//缓慢的滑出
.active {
  width: 0px !important;
}
</style>
<style scoped></style>
